import { useState } from 'react';
import { WheelDatePickerField } from '@/components/ui/wheel-date-picker';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function DebugCalendarPage() {
  const [date, setDate] = useState<Date | null>(new Date());

  return (
    <div className="p-8 flex items-center justify-center min-h-screen bg-slate-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Date Picker Debug</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Select Date</label>
            <WheelDatePickerField value={date} onChange={(d) => setDate(d)} />
          </div>
          <div className="p-4 bg-slate-100 rounded text-xs font-mono">
            Selected: {date ? date.toISOString() : 'null'}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
